import { createSelector } from '@reduxjs/toolkit'

const getArcCategoriesState = (state) => state.arcCategories

export const getArcCategories = createSelector(
  getArcCategoriesState,
  (state) => state.categories
)

export const getIsLoaded = createSelector(
  getArcCategoriesState,
  (state) => state.isLoaded
)

export const getIsSavingActive = createSelector(
  getArcCategoriesState,
  (state) => state.isSavingActive
)